
import { defineComponent, onBeforeMount, reactive } from 'vue'

import type { GetWaybillParamsFilters } from '@/modern/modules/m-dispatcher-module/services/types/waybill.types'

// > legacy/types/couriers <
import { DispatcherCourierT } from '@/core/types/couriers.types'

// > legacy/types/carriers <
import { CarrierT } from '@/core/types/carriers.types'

// > legacy/types/cities <
import { CityT } from '@/core/types/cities.types'

// > legacy/realisations/couriers <
import { couriers } from '@/core/realisations/couriers.realisation'

// > legacy/realisations/carriers <
import { carriers } from '@/core/realisations/carriers.realisation'

// > legacy/realisations/cities <
import { cities } from '@/core/realisations/cities.realisation'

// const CALCULATION_TYPES = [
//     { id: 1, name: 'Грузовые машины' },
//     { id: 2, name: 'Стандартный' },
//     { id: 3, name: 'Ставка-стоп' },
//     { id: 4, name: 'Встреча-выдача' },
//     { id: 5, name: 'Посёлки' },
//     { id: 6, name: 'Час' },
//     { id: 7, name: 'День' },
//     { id: 8, name: 'Рейс' }
// ]

const PAYMENT_TYPES = [
    { id: 1, name: 'Оплата наличными' },
    { id: 2, name: 'Оплата переводом' }
]

const STATUSES = [
    { id: 60, name: 'Оплачен' },
    { id: 61, name: 'Отказ от оплаты' },
    { id: 62, name: 'Ожидает оплаты' }
]

const TYPES = [
    { id: 1, name: 'Встреча-выдача' },
    { id: 2, name: 'Поселки' },
    { id: 3, name: 'ВНГ' }
]

export default defineComponent({
    props: {
        loading: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['submit', 'reset'],
    setup(props, { emit }) {
        const state = reactive({
            dateFrom: null as string | null,
            dateTo: null as string | null,
            codeOneC: null as string | null,
            companyId: null as number | null,
            courierId: null as number | null,
            statusId: null as number | null,
            paymentTypeId: null as number | null,
            waybillTypeId: null as number | null,
            cityId: null as number | null,
        })

        const data_state = reactive({
            carriers: {
                isLoading: false,
                isFailed: false,
                list: [] as CarrierT[]
            },
            couriers: {
                isLoading: false,
                isFailed: false,
                list: [] as DispatcherCourierT[]
            },
            cities: {
                isLoading: false,
                isFailed: false,
                list: [] as CityT[]
            }
        })

        const loadCarriers = async () => {
            try {
                data_state.carriers.isLoading = true

                const response = await carriers.getList({ page: 1, limit: 9999, statusId: 2 })

                data_state.carriers.list = response.data

                data_state.carriers.isFailed = false
            } catch (error) {
                console.error(error)
                data_state.carriers.isFailed = true
            } finally {
                data_state.carriers.isLoading = false
            }
        }

        const loadCouriers = async () => {
            try {
                data_state.couriers.isLoading = true

                const response = await couriers.getList({ page: 1, limit: 9999 })

                data_state.couriers.list = response.data

                data_state.couriers.isFailed = false
            } catch (error) {
                console.error(error)
                data_state.couriers.isFailed = true
            } finally {
                data_state.couriers.isLoading = false
            }
        }

        const loadCities = async () => {
            try {
                data_state.cities.isLoading = true

                const response = await cities.getAllList(1, undefined, 9999)

                data_state.cities.list = response.data

                data_state.cities.isFailed = false
            } catch (error) {
                console.error(error)
                data_state.cities.isFailed = true
            } finally {
                data_state.cities.isLoading = false
            }
        }

        onBeforeMount(() => {
            loadCarriers()
            loadCouriers()
            loadCities()
        })

        const onSubmit = () => {
            if (props.loading) return

            const params: GetWaybillParamsFilters = {
                dateFrom: state.dateFrom,
                dateTo: state.dateTo,
                codeOneC: state.codeOneC,
                companyId: state.companyId,
                courierId: state.courierId,
                statusId: state.statusId,
                paymentTypeId: state.paymentTypeId,
                waybillTypeId: state.waybillTypeId,
                cityId: state.cityId
            }

            emit('submit', params)
        }

        const onReset = () => {
            if (props.loading) return

            state.dateFrom = null
            state.dateTo = null
            state.codeOneC = null
            state.companyId = null
            state.courierId = null
            state.statusId = null
            state.paymentTypeId = null
            state.waybillTypeId = null
            state.cityId = null

            emit('reset')
        }

        return {
            PAYMENT_TYPES,
            STATUSES,
            TYPES,
            state,
            data_state,
            loadCarriers,
            loadCouriers,
            loadCities,
            onSubmit,
            onReset
        }
    }
})
